import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';
import { Text } from 'components/core';
import { Styled } from './password-criteria-check.style';

import {
  numberRegex,
  specialCharacterRegex,
  upperCaseRegex,
} from '../password-validations';

interface PasswordCriteriaCheckProps {
  className?: string;

  password: string;
}

export const PasswordCriteriaCheck: React.FC<PasswordCriteriaCheckProps> = ({
  className,
  password,
}) => {
  const passwordHasNumber = password?.match?.(numberRegex);
  const passwordHasSpecialCharacter = password?.match?.(specialCharacterRegex);
  const passwordHasUpperCaseCharacter = password?.match?.(upperCaseRegex);
  const passwordValidationCriteria = [
    {
      text: 'Eight characters',
      isValid: password?.length > 7,
    },
    {
      text: 'One number',
      isValid: passwordHasNumber !== null && passwordHasNumber !== undefined,
    },
    {
      text: 'One special character',
      isValid:
        passwordHasSpecialCharacter !== null &&
        passwordHasSpecialCharacter !== undefined,
    },
    {
      text: 'One upper-case letter',
      isValid:
        passwordHasUpperCaseCharacter !== null &&
        passwordHasUpperCaseCharacter !== undefined,
    },
  ];

  return (
    <Styled.PasswordCriteriaBox className={className} p={2}>
      <ul>
        {passwordValidationCriteria.map((criteria) => {
          return (
            <li key={criteria.text}>
              <Box mb={0.5}>
                <Grid container>
                  <Grid item>
                    <Box mr={1}>
                      <Styled.IconCheck $isValid={criteria.isValid} />
                    </Box>
                  </Grid>

                  <Grid item>
                    <Text color="black" variant={1}>
                      {criteria.text}
                    </Text>
                  </Grid>
                </Grid>
              </Box>
            </li>
          );
        })}
      </ul>
    </Styled.PasswordCriteriaBox>
  );
};

PasswordCriteriaCheck.propTypes = {
  password: PropTypes.string.isRequired,
};
